/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/UsageTable.js
 */

import React, { Component } from 'react';
import ReactTable from 'react-table';
// import 'react-table/react-table.css';

export class UsageTable extends Component {
  render() {
    let usageData = findUsageRatingInformationForFeatureDetail(
      this.props.usageData.getInvoiceOwningCustomerAccount,
      this.props.featureDetail
    );
    if (!usageData) return <div></div>;

    const {
      unitOfMeasure,
      availableUnits,
      consumedUnits,
      overage,
      percentConsumedUnits,
    } = this.usageData;

    const data = [
      {
        unitOfMeasure: unitOfMeasure,
        availableUnits: availableUnits,
        consumedUnits: consumedUnits,
        overage: overage,
        percentConsumedUnits: !percentConsumedUnits
          ? '0%'
          : percentConsumedUnits + '%',
      },
    ];

    const columns = [
      {
        Header: 'Unit of Measure',
        accessor: 'unitOfMeasure',
        headerClassName: 'usage-table-column',
      },
      {
        Header: 'Availabe Units',
        accessor: 'availableUnits',
        minWidth: 60,
        headerClassName: 'usage-table-column',
      },
      {
        Header: 'Consumed Units',
        accessor: 'consumedUnits',
        minWidth: 60,
        headerClassName: 'usage-table-column',
      },
      {
        Header: 'Overage',
        accessor: 'overage',
        minWidth: 50,
        headerClassName: 'usage-table-column',
      },
      {
        Header: 'Percent Consumed Units',
        accessor: 'percentConsumedUnits',
        headerClassName: 'usage-table-column',
      },
    ];

    return (
      <div>
        <ReactTable
          className="usage-table"
          data={data}
          columns={columns}
          showPagination={false}
          defaultPageSize={1}
          resizable={false}
          sortable={false}
        />
        <a
          href={`https://edw.sanjuan.avalara.com/ReportServer/Pages/ReportViewer.aspx?%2fBillableUsage%2fBT+UsageDetail&rs:Command=Render&CustomerAccountID=${this.props.customerAccountId}`}
        >
          View in Usage Report
        </a>
      </div>
    );
  }
}

export function findUsageRatingInformationForFeatureDetail(
  usageData,
  featureDetail
) {
  let matchedUOM;

  if (!usageData || !usageData.unitsOfMeasure) return false;

  usageData.unitsOfMeasure.forEach((uom) => {
    let matchedRatePlan = uom.ratePlanOwningCustomerAccounts.find(
      (rpoca) =>
        rpoca &&
        rpoca.ratingPlanInformation &&
        rpoca.ratingPlanInformation.featureDetail &&
        rpoca.ratingPlanInformation.featureDetail.id === featureDetail.id
    );
    if (matchedRatePlan) {
      matchedUOM = uom;
    }
  });

  return matchedUOM;
}

// export function findUsageRatingInformationForObligationSummaries(
//   usageData,
//   obligationSummaries
// ) {
//   obligationSummaries.reduce((accumulator, summary) => {
//     let usage = findUsageRatingInformationForFeatureDetail(
//       usageData,
//       summary.featureDetail
//     );
//     return usage || accumulator;
//   }, false);
// }
